<template>
  <div class="link-setting">
    <div class="top">
      <div class="flex-item">
        <b>对外联系方式</b>
        <span class="tip">设置完成后，客户可通过该方式联系贵司</span>
      </div>
      <div class="flex-item">
        <template v-if="!isEdit">
          <el-button @click="handleEdit" type="primary">设置</el-button>
        </template>
        <template v-else>
          <el-button plain @click="handleClose">取消</el-button>
          <el-button @click="handleSave" type="primary">保存</el-button>
        </template>
      </div>
    </div>
    <div class="content">
      <template v-if="!isEdit">
        <el-descriptions :colon="false" size="medium">
          <el-descriptions-item label="对外联系方式">{{ info.serviceTel || '--' }}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else>
        <el-form :model="form" ref="JZForm" :rules="rules" size="mini" label-position="right" label-width="120px">
          <el-form-item label="对外联系方式" prop="serviceTel">
            <el-input v-model.trim="form.serviceTel" clearable placeholder="请输入" style="width: 300px;" />
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>
<script>
import { saveServiceTel } from '@/api/shop';

export default {
  data () {
    return {
      isEdit: false,
      info: {
        tenantId: '',
        serviceTel: '',
      },
      form: {
        serviceTel: '',
      },
      rules: {
        serviceTel: [
          { required: true, message: '请输入对外联系方式', trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  watch: {
    isEdit (v) {
      if (v) {
        this.form = JSON.parse(JSON.stringify(this.info));
      }
    },
  },
  methods: {
    handleEdit () {
      this.isEdit = !this.isEdit;
    },
    handleClose () {
      this.handleEdit();
    },
    handleSave () {
      this.$refs.JZForm.validate().then(async valid => {
        if (valid) {
          await saveServiceTel({
            tenantId: this.form.tenantId,
            serviceTel: this.form.serviceTel,
          });
          this.$message.success('保存成功');
          this.info = this.form;
          this.handleEdit();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.link-setting {
  font-size: 14px;
  color: #1F2733;

  .flex-item {
    display: inline-flex;
    align-items: center;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eeeeee;

    .tip {
      font-weight: 400;
      font-size: 12px;
      color: #929AA6;
      margin: 0 15px;
    }
  }

  .content {
    padding: 20px;
    /deep/ .el-descriptions-item__label {
      color: #929AA6;
    }
  }
}
</style>
